import React, { useState, useEffect } from 'react';
import '../../../style/Arrears/ArrearsSeventhResult.css';
// import DaArrearsResultPDF from './daArrearsResultPDF';// Import PDF download component
import { useParams } from 'react-router-dom';
import InteractivePDFWrapper from './PDFUIWrapper';
import { sendEmail } from './daArrearsMail';
import LoadingPage from '../../Loader';
import SubmissionConfirmation from '../../pages/dataSubmit/dataSubmitted'

const DaArrearsResult = () => {
  const { uniqueFormId } = useParams(); // Get uniqueFormId from URL
  const [result, setResult] = useState([]);
  const [info, setInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [emailSent, setEmailSent] = useState(false);

  useEffect( () => {
    const fetchData = async () => {
   
  
      try {
        

        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/daArrearsForm/daArrears-result/${uniqueFormId}`);
        
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
  
        // Format the info object and then set it
        const formattedInfo = {
          ...data.info,
          arrearsEndDate: new Date(data.info.arrearsEndDate).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }),
        };
  
        setInfo(formattedInfo);  // Only call setInfo once
        setResult(Array.isArray(data.result) ? data.result : []);  // Update result
  
         // Send email only if it hasn't been sent yet
      if (!emailSent) {
        await sendEmail(data.result, formattedInfo); // Pass the data correctly
        setEmailSent(true); // Set the flag to true after sending the email
      }

      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }

    };
       
    fetchData();
  }, [uniqueFormId, emailSent]); // Dependency on uniqueFormId (or any other state/props that should trigger this effect)


    if (loading) return <LoadingPage />;
    // if (error || !result) return <SubmissionConfirmation uniqueFormId={uniqueFormId} />;
    if (error || !result) return <div>Error: {error}</div>;


  // Pagination Logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = result.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(result.length / rowsPerPage);


  return (
    <div className="legal-page">
      <header>
        <label>D.A. Arrears July24</label>
        Date: {`${String(new Date().getDate()).padStart(2, '0')}/${String(new Date().getMonth() + 1).padStart(2, '0')}/${new Date().getFullYear()}`}
      </header>

      <main>
        <div className="legal-table-container">
        <div className="employee-info">
          <div>
            <label>{info.officeName}</label>
          </div>
          <p>Statement showing the difference of D.A. & H.R.A. payable due to revision of D.A. Rates for the period: 01/07/2024 to {info.arrearsEndDate}</p>
          <div>
            <label>{info.employeeName}</label>
          </div>
          <div>
            <label>DESIGNATION: {info.designation}</label>
          </div>
        </div>
          {/* Salary Section Header */}
          <table className="legal-table">
            <thead>
              <tr className="salary-header">
                <th colSpan="2"></th>
                <th colSpan="6">DUE SALARY</th>
                <th colSpan="6">DRAWN SALARY</th>
                <th colSpan="5">DIFFERENCE</th>
                <th colSpan="3">PROF. TAX</th>
                <th colSpan="1"></th>
              </tr>
              <tr>
                <th>Sr.No.</th>
                <th>Month</th>
                <th>Basic Pay</th>
                <th>%DA</th>
                <th>DA</th>
                <th>HRA</th>
                <th>TRA</th>
                <th>Total</th>

                <th>Basic Pay</th>
                <th>%DA</th>
                <th>DA</th>
                <th>HRA</th>
                <th>TRA</th>
                <th>Total</th>

                <th>Basic Pay</th>
                <th>DA</th>
                <th>HRA</th>
                <th>TRA</th>
                <th>Total</th>

                <th>Due PT</th>
                <th>Drawn PT</th>
                <th>PTRec</th>
                <th>Net</th>
              </tr>
            </thead>
            <tbody>
              {currentRows.length > 0 ? (
                currentRows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>{indexOfFirstRow + rowIndex + 1}</td>
                    {row.map((cell, cellIndex) => {
                      const cellStyle = cellIndex >= 13 && cellIndex <= 17 ? { backgroundColor: 'rgba(46, 204, 113, 0.05)' } : {};
                      return <td key={cellIndex} style={cellStyle}>{cell}</td>;
                    })}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="23">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </main>


      <div className="page-nav">

        <button onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))}>Previous</button>
        <InteractivePDFWrapper result={result} info={info} />
        <button onClick={() => setCurrentPage(Math.min(currentPage + 1, totalPages))}>Next</button>
      </div>
      <p>Page {currentPage} of {totalPages}</p>
      
    </div>
  );
};

export default DaArrearsResult;
